export const glowOuterStyle = {
  background: "radial-gradient(closest-side, var(--privacy-glow-outer) 0%, transparent 100%)",
} as const;

export const glowInnerStyle = {
  background: "radial-gradient(closest-side, var(--privacy-glow-inner) 0%, transparent 100%)",
} as const;
